module.exports = __webpack_public_path__ + "img/15.039e52e9.jpg";